import { formatMoney } from '@/lib/format';
import { rideFareLineLabel } from '@/lib/ride-format';
import type { RideMoney, RideQuote } from '@/lib/rides-types';

export function RideFareCard({
  quote,
  fare,
  paymentNote,
}: {
  quote?: RideQuote;
  fare?: RideMoney;
  paymentNote?: string;
}) {
  const total = quote?.total ?? fare;
  const breakup = quote?.breakup ?? [];

  return (
    <div className="wb-card wb-card--pad">
      {breakup.length > 0 && (
        <div className="wb-col wb-gap-8" style={{ marginBottom: 12 }}>
          {breakup.map((line, index) => (
            <div className="wb-row wb-between" key={`${line.title}:${index}`}>
              <span className="wb-small">{rideFareLineLabel(line.title)}</span>
              <span className="wb-small" style={{ color: 'var(--ink)' }}>
                {formatMoney(line.amount)}
              </span>
            </div>
          ))}
          <hr className="wb-divider" style={{ margin: '4px 0 0' }} />
        </div>
      )}
      <div className="wb-row wb-between">
        <span className="wb-sub">Fare</span>
        <span className="wb-strong" style={{ color: 'var(--ink)' }}>
          {formatMoney(total)}
        </span>
      </div>
      {paymentNote && (
        <p className="wb-tiny" style={{ marginTop: 8 }}>
          {paymentNote}
        </p>
      )}
    </div>
  );
}